import(/* webpackMode: "eager", webpackExports: ["Background"] */ "/vercel/path0/frontend/src/app/components/Background/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelecaoForm"] */ "/vercel/path0/frontend/src/app/selecao/components/Form/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/selecao/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["Content","FormDescription"] */ "/vercel/path0/frontend/src/app/selecao/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/src/components/BlurGroup/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/vercel/path0/node_modules/.pnpm/react-toastify@9.1.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/react-toastify@9.1.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-toastify/dist/ReactToastify.css");
